
import { AdminAnalyticsService } from "../../../services/admin-analytics.service.js";

export const AnalyticsTab = async (container) => {
    // This is the "Trends" tab (restored)

    // --- Render Frame ---
    container.innerHTML = `
        <div class="flex flex-col gap-6 animate-fade-in pb-10">
            <!-- Header -->
            <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex justify-between items-center">
                <div>
                    <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-2">
                        <span class="material-symbols-outlined text-indigo-600">trending_up</span> 
                        Platform Trends
                    </h2>
                    <p class="text-sm text-gray-500">Real-time content popularity and user engagement insights.</p>
                </div>
                <button id="btn-refresh-trends" class="bg-gray-100 hover:bg-gray-200 text-gray-600 p-2 rounded-lg transition-colors">
                    <span class="material-symbols-outlined">refresh</span>
                </button>
            </div>

            <!-- 0. [NEW] Global User Stats (Product Hunt Special) -->
            <div class="bg-white rounded-xl border border-indigo-100 shadow-sm overflow-hidden mb-2">
                <div class="p-4 border-b border-gray-100 bg-gradient-to-r from-indigo-50 to-white flex justify-between items-center">
                    <h3 class="font-bold text-gray-800 flex items-center gap-2">
                         <span class="material-symbols-outlined text-indigo-600">public</span> 
                         Global User Real-time (Today)
                    </h3>
                    <span class="text-xs font-mono text-indigo-400 bg-white px-2 py-1 rounded border border-indigo-100">
                        ${new Date().toISOString().split('T')[0]}
                    </span>
                </div>
                <div id="locale-stats-container" class="p-6">
                    <div class="text-center text-gray-400 text-sm py-4"><span class="loader-spin w-5 h-5 border-2 border-gray-300 border-t-indigo-600 rounded-full animate-spin inline-block"></span> Loading Stats...</div>
                </div>
            </div>

            <!-- 1. Trending Content (Series) -->
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                    <div class="p-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
                        <h3 class="font-bold text-gray-800 flex items-center gap-2">
                             <span class="material-symbols-outlined text-pink-500">local_fire_department</span> Top 10 Series (Views)
                        </h3>
                    </div>
                    <div id="trend-series-list" class="divide-y divide-gray-100 max-h-[400px] overflow-y-auto">
                        <div class="p-8 text-center"><span class="loader-spin w-6 h-6 border-2 border-gray-300 border-t-indigo-600 rounded-full animate-spin inline-block"></span></div>
                    </div>
                </div>

                <!-- 2. Trending Activity (Feeds) -->
                 <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                    <div class="p-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
                        <h3 class="font-bold text-gray-800 flex items-center gap-2">
                             <span class="material-symbols-outlined text-blue-500">forum</span> Top 10 Feeds (Likes)
                        </h3>
                    </div>
                    <div id="trend-feeds-list" class="divide-y divide-gray-100 max-h-[400px] overflow-y-auto">
                        <div class="p-8 text-center"><span class="loader-spin w-6 h-6 border-2 border-gray-300 border-t-indigo-600 rounded-full animate-spin inline-block"></span></div>
                    </div>
                </div>
            </div>

            <!-- 3. [GROWTH] Viral & Share Analytics -->
            <div class="mt-8 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl p-1 shadow-lg text-white">
                <div class="bg-white/10 backdrop-blur-lg rounded-lg p-6">
                    <h3 class="font-bold text-lg mb-4 flex items-center gap-2">
                        <span class="material-symbols-outlined text-yellow-300">share</span> 
                        Viral Analytics (Share Links)
                    </h3>
                    
                    <div class="bg-white rounded-lg overflow-hidden text-gray-900 shadow-inner">
                        <div class="grid grid-cols-12 bg-gray-50 p-3 text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                            <div class="col-span-6">Campaign / Series</div>
                            <div class="col-span-2 text-right">Total Hits</div>
                            <div class="col-span-2 text-right text-green-600">Humans (Click)</div>
                            <div class="col-span-2 text-right text-orange-500">Bots (Scrape)</div>
                        </div>
                        <div id="viral-stats-list" class="divide-y divide-gray-100 max-h-[300px] overflow-y-auto">
                            <!-- Dynamic Content -->
                            <div class="p-8 text-center text-gray-400"><span class="loader-spin w-5 h-5 border-2 border-gray-300 border-t-indigo-600 rounded-full animate-spin inline-block"></span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

    // --- Logic ---
    const loadTrends = async () => {
        const seriesContainer = container.querySelector('#trend-series-list');
        const feedsContainer = container.querySelector('#trend-feeds-list');

        try {
            const [series, feeds] = await Promise.all([
                AdminAnalyticsService.getTrendingContent(10),
                AdminAnalyticsService.getTrendingFeeds(10)
            ]);

            // Render Series
            if (series.length > 0) {
                seriesContainer.innerHTML = series.map((s, idx) => `
                    <div class="p-4 flex items-center gap-4 hover:bg-gray-50 transition-colors">
                        <div class="font-black text-xl text-gray-300 w-6 text-center">${idx + 1}</div>
                        <div class="w-12 h-12 rounded bg-gray-200 overflow-hidden flex-shrink-0">
                            ${s.thumbnailUrl ?
                        `<img src="${s.thumbnailUrl}" class="w-full h-full object-cover" onerror="this.parentElement.innerHTML='<span class=\\'material-symbols-outlined text-gray-400 text-2xl m-auto\\'>image_not_supported</span>'">`
                        : `<div class="w-full h-full flex items-center justify-center bg-gray-100"><span class="material-symbols-outlined text-gray-300 text-lg">image</span></div>`
                    }
                        </div>
                        <div class="flex-1 min-w-0">
                            <h4 class="font-bold text-gray-900 text-sm truncate">${s.title}</h4>
                            <p class="text-xs text-gray-500 truncate">${(s.authorName && s.authorName !== 'undefined') ? s.authorName : 'Unknown Author'}</p>
                        </div>
                        <div class="text-right">
                            <div class="text-xs font-bold text-gray-900">${(s.viewCount || 0).toLocaleString()}</div>
                            <div class="text-[10px] text-gray-400">Views</div>
                        </div>
                    </div>
                `).join('');
            } else {
                seriesContainer.innerHTML = `<div class="p-8 text-center text-gray-400 text-sm">No trending series data available.</div>`;
            }

            // Render Feeds
            if (feeds.length > 0) {
                feedsContainer.innerHTML = feeds.map((f, idx) => `
                    <div class="p-4 flex items-center gap-4 hover:bg-gray-50 transition-colors">
                        <div class="font-black text-xl text-gray-300 w-6 text-center">${idx + 1}</div>
                        <div class="flex-1 min-w-0">
                            <h4 class="font-medium text-gray-900 text-sm line-clamp-2">${f.content || 'No text content'}</h4>
                            <p class="text-[10px] text-gray-500 mt-1">${f.authorName || 'Anonymous'} • ${new Date(f.createdAt?.seconds * 1000).toLocaleDateString()}</p>
                        </div>
                        <div class="text-right">
                             <div class="text-xs font-bold text-pink-500 flex items-center justify-end gap-1">
                                <span class="material-symbols-outlined text-[12px]">favorite</span> ${(f.likeCount || 0).toLocaleString()}
                             </div>
                        </div>
                    </div>
                `).join('');
            } else {
                feedsContainer.innerHTML = `<div class="p-8 text-center text-gray-400 text-sm">No trending feeds data available.</div>`;
            }

        } catch (e) {
            console.error("Trend Load Error:", e);
            container.querySelector('#trend-series-list').innerHTML = `<div class="p-4 text-red-500 text-sm">Error loading trends.</div>`;
        }

        // [GROWTH] Load Viral Stats Independently (Non-blocking)
        AdminAnalyticsService.getMostSharedContent(10).then(shared => {
            const viralContainer = container.querySelector('#viral-stats-list');
            if (shared.length > 0) {
                viralContainer.innerHTML = shared.map(item => `
                    <div class="grid grid-cols-12 p-3 text-sm hover:bg-indigo-50 transition-colors items-center">
                        <div class="col-span-6 font-medium truncate pr-2">
                            <span class="px-1.5 py-0.5 rounded text-[10px] bg-gray-100 text-gray-500 mr-2">${item.type || 'Link'}</span>
                            ${item.title || 'Untitled'}
                        </div>
                        <div class="col-span-2 text-right font-bold">${(item.totalHits || 0).toLocaleString()}</div>
                        <div class="col-span-2 text-right text-green-600 bg-green-50 rounded px-1 ml-auto font-mono text-xs py-1">
                            ${(item.humanHits || 0).toLocaleString()}
                        </div>
                        <div class="col-span-2 text-right text-orange-500 font-mono text-xs opacity-80">
                            ${(item.botHits || 0).toLocaleString()}
                        </div>
                    </div>
                `).join('');
            } else {
                viralContainer.innerHTML = `<div class="p-8 text-center text-gray-400 text-sm">아직 공유 데이터가 충분하지 않습니다.</div>`;
            }
        }).catch(err => {
            console.error(err);
            container.querySelector('#viral-stats-list').innerHTML = `<div class="p-4 text-red-400 text-xs text-center">Failed to load viral stats</div>`;
        });

        // [NEW] Load Locale Stats (Internal)
        import("../../../services/admin-overview.service.js").then(({ AdminOverviewService }) => {
            // Re-use the method we added to AdminOverviewService for consistency
            // Note: _fetchLocaleStats is private-ish, but let's assume we can export it or add a public getter.
            // Actually, we added it as `_fetchLocaleStats`. Let's expose a public method `getDailyLocaleStats`.
            // Wait, I can't easily change the service again without another tool call.
            // I'll just query it directly here or use the private method if JS allows (it does).
            // Better yet, let's just query it here to be safe and independent.

            const fetchLocale = async () => {
                try {
                    const { getFirestore, collection, query, where, getDocs } = await import("firebase/firestore");
                    const { app } = await import("../../../firebase-config.js");
                    const db = getFirestore(app);
                    const today = new Date().toISOString().split('T')[0];
                    const q = query(
                        collection(db, 'stats_daily_locale'),
                        where('date', '==', today)
                    );
                    const snap = await getDocs(q);
                    const stats = snap.docs.map(d => ({
                        lang: d.data().lang,
                        count: (d.data().signup_count || 0) + (d.data().login_count || 0)
                    })).sort((a, b) => b.count - a.count);

                    const el = container.querySelector('#locale-stats-container');
                    if (stats.length > 0) {
                        // Render Bar Chart using HTML/CSS
                        const max = stats[0].count;
                        el.innerHTML = `
                            <div class="space-y-3">
                                ${stats.map(s => {
                            const percent = (s.count / max) * 100;
                            const flag = {
                                'ko': '🇰🇷', 'en': '🇺🇸', 'ja': '🇯🇵', 'zh': '🇨🇳', 'vi': '🇻🇳',
                                'th': '🇹🇭', 'es': '🇪🇸', 'fr': '🇫🇷', 'de': '🇩🇪', 'ru': '🇷🇺'
                            }[s.lang] || '🌐';
                            const label = {
                                'ko': 'Korean', 'en': 'English', 'ja': 'Japanese', 'zh': 'Chinese', 'vi': 'Vietnamese',
                                'th': 'Thai', 'es': 'Spanish', 'fr': 'French', 'de': 'German', 'ru': 'Russian'
                            }[s.lang] || s.lang;

                            return `
                                    <div class="flex items-center gap-3">
                                        <div class="w-24 text-sm font-bold text-gray-600 flex items-center gap-2">
                                            <span class="text-lg">${flag}</span> ${label}
                                        </div>
                                        <div class="flex-1 bg-gray-100 rounded-full h-4 overflow-hidden relative">
                                            <div class="bg-indigo-500 h-full rounded-full" style="width: ${percent}%"></div>
                                        </div>
                                        <div class="w-12 text-right font-mono font-bold text-indigo-600">${s.count}</div>
                                    </div>
                                    `;
                        }).join('')}
                            </div>
                        `;
                    } else {
                        el.innerHTML = `<div class="text-center text-gray-400 py-4">No activity yet today.</div>`;
                    }
                } catch (e) {
                    console.error("Locale Stats Error", e);
                    container.querySelector('#locale-stats-container').innerHTML = `<div class="text-red-400 text-sm">Load Error</div>`;
                }
            };
            fetchLocale();
        });
    };

    container.querySelector('#btn-refresh-trends').onclick = async (e) => {
        const btn = e.currentTarget;
        const icon = btn.querySelector('span');

        // [UX] Visual Feedback
        icon.classList.add('animate-spin');
        btn.disabled = true;
        btn.classList.add('opacity-50', 'cursor-not-allowed');

        await loadTrends();

        // Restore
        setTimeout(() => {
            icon.classList.remove('animate-spin');
            btn.disabled = false;
            btn.classList.remove('opacity-50', 'cursor-not-allowed');
        }, 500); // 0.5s minimum delay for feel
    };
};
